import React, {useRef} from 'react';
import {observer} from "mobx-react-lite";
import {
    ISeatFilterViewModel
} from "../../../../../services/booking/models/seat-maps/filters/seat-filter.view-model.interface";
import styled, {css} from "styled-components";
import {useServices} from "../../../../../hooks/use-services.hook";
import {ZIndex} from "../../../../../types/z-index";
import {
    ITooltipController,
    TooltipComponent,
    TooltipToggleBehaviorEnum
} from "../../../../../components/tooltip/tooltip.component";
import {
    CSS_VAR_TOOLTIP_BACKGROUND_COLOR,
    CSS_VAR_TOOLTIP_COLOR
} from "../../../../../components/tooltip/tootip-css-constants";

const SeatFiltersBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-end;
    gap: ${props => props.theme.spacing.flexGap16};
    font-size: ${props => props.theme.fontSize.body2};
    font-weight: ${props => props.theme.fontWeight.bold};
`

const SeatFilterBox = styled.div<{$isApplied: boolean}>`
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-items: center;
    gap: ${props => props.theme.spacing.flexGap8};
    cursor: pointer;
    padding: ${props => props.theme.spacing.spacing8} ${props => props.theme.spacing.spacing12};
    border-radius: ${props => props.theme.border.defaultRadius};
    width: 40px;
    ${props => props.$isApplied 
                ? css`
                    background-color: ${props => props.theme.colors.primary};
                    color: ${props => props.theme.colors.primaryContrast};
                    box-shadow: ${props => props.theme.boxShadow.dropShadow};
                `
                : css`
                    background-color: ${props => props.theme.colors.darkTint};
                    color: ${props => props.theme.colors.darkContrast};
                `
    }
`


const SeatFilterIconBox = styled.div`
    
`

const TooltipBox = styled(TooltipComponent)`
    ${CSS_VAR_TOOLTIP_BACKGROUND_COLOR}: ${props => props.theme.colors.primary};
    ${CSS_VAR_TOOLTIP_COLOR}: ${props => props.theme.colors.primaryContrast};
`

const SeatFilterDescriptionBox = styled.div`
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primaryContrast};
  text-align: center;
  padding: ${props => props.theme.spacing.spacing12};
  border-radius: ${props => props.theme.border.defaultRadius};
  z-index: ${ZIndex.DropDownPopper};
  width: 200px;
`

const LabelBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${props => props.theme.colors.darkTint};
`

interface SeatFilterComponentProps {
    filter: ISeatFilterViewModel;
}
const SeatFilterComponent: React.FC<SeatFilterComponentProps> = observer((props) => {

    const seatFilterElementRef = useRef<HTMLDivElement | null>(null);
    const tooltipControllerRef = useRef<ITooltipController | null>(null);

    const onClick = () => {
        props.filter.isApplied = !props.filter.isApplied;
    }

    return (
        <SeatFilterBox $isApplied={props.filter.isApplied}
                       ref={seatFilterElementRef}
                       onClick={onClick}>
            <SeatFilterIconBox>
                {props.filter.renderIcon()}
            </SeatFilterIconBox>
            <TooltipBox placement={"bottom"}
                        targetRef={seatFilterElementRef}
                        showCloseButton={false}
                        tooltipControllerRef={tooltipControllerRef}
                        toggleBehavior={TooltipToggleBehaviorEnum.OnTargetMouseEnterLeave}>
                <SeatFilterDescriptionBox>
                    {props.filter.description}
                </SeatFilterDescriptionBox>
            </TooltipBox>
        </SeatFilterBox>

    )
});

export const SeatFiltersComponent: React.FC<{className?: string}> = observer((props) => {
    const services = useServices();
    const filters = services.booking.current.seatsMapsEditors.seatFilters;
    return (
        <SeatFiltersBox className={props.className}>
            <LabelBox>{services.language.translate('Show only seats suitable for:')}</LabelBox>
            {filters.map(f => <SeatFilterComponent key={f.description} filter={f}/>)}
        </SeatFiltersBox>
    )
})
